import axios from "axios";

export default function WorktypeDeleteService(id) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/worktype/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
